module.exports = __webpack_public_path__ + "img/imagen8.bcb021d9.png";